import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private httpClient:HttpClient) { }

  server_url = 'http://localhost:3000/upload';

  uploadData(data){
    // uploadUrl=''
    return this.httpClient.post<any>(this.server_url,data)
  }

}
